let scrollPosition = 0;
let previousOverflow = '';

export const lockScroll = () => {
    scrollPosition = window.pageYOffset;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.height = '100dvh';
};

export const unlockScroll = () => {
    document.body.style.overflow = previousOverflow;
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('height');
    window.scrollTo(0, scrollPosition);
};
